module.exports = __webpack_public_path__ + "img/oxford.bb9f4d15.png";